if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.forms = Array.from(this.querySelectorAll('form'));
      this.form = this.forms[0] || null;
      this.forms.forEach((form) => {
        const idInput = form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        form.addEventListener('submit', this.onSubmitHandler.bind(this, form));
      });
      this.cartNotification = document.querySelector('cart-notification');
    }

    async openThemeCartDrawer() {
      const drawer = document.getElementById('CartDrawer545');
      if (!drawer) return false;

      try {
        const res = await fetch('/?sections=cart-drawer-545', {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        const data = await res.json();
        const html = data['cart-drawer-545'];

        if (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('#CartDrawer545');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
          }
        }

        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-545--open');
        window.FIVEFOURFIVE_RECENTLY_VIEWED?.render(drawer);
        return true;
      } catch (e) {
        return false;
      }
    }

    getSelectedCompleteLookVariantId(formData, form) {
      const sectionEl = this.closest('[data-pdp-545]') || form.closest('[data-pdp-545]');
      const completeLookBlock = sectionEl?.querySelector('[data-complete-look]:not([hidden])');
      if (!completeLookBlock) return '';

      const selectedBlock = completeLookBlock.matches('[data-selected-variant-id]:not([data-selected-variant-id=""])')
        ? completeLookBlock
        : null;
      const selectedBlockVariantId = selectedBlock?.dataset.selectedVariantId || '';
      if (selectedBlockVariantId) return selectedBlockVariantId;

      const selectedInput = completeLookBlock.querySelector('[data-complete-look-option]:checked:not(:disabled)');
      const selectedVariantId = selectedInput?.dataset.variantId || '';
      if (selectedVariantId) return selectedVariantId;

      const selectedLabel = completeLookBlock.querySelector('[data-complete-look-size-option].is-selected');
      const selectedLabelVariantId = selectedLabel?.dataset.variantId || '';
      if (selectedLabelVariantId) return selectedLabelVariantId;

      const selectedUrlVariantId = new URLSearchParams(window.location.search).get('complete_variant') || '';
      if (selectedUrlVariantId) return selectedUrlVariantId;

      return formData.get('complete_look_variant_id') || '';
    }

    getMainVariantId(formData) {
      return Number(formData.get('id')) || Number(new URLSearchParams(window.location.search).get('variant')) || 0;
    }

    getBundlePayload(formData, completeLookVariantId) {
      const mainVariantId = this.getMainVariantId(formData);
      if (!mainVariantId || !completeLookVariantId) return null;

      const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);

      return {
        items: [
          {
            id: mainVariantId,
            quantity
          },
          {
            id: completeLookVariantId,
            quantity: 1
          }
        ]
      };
    }

    appendCartNotificationSections(target) {
      if (!this.cartNotification || window.FIVEFOURFIVE_CART_DRAWER) return;

      const sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
      if (target instanceof FormData) {
        target.append('sections', sections);
        target.append('sections_url', window.location.pathname);
        return;
      }

      target.sections = sections.join(',');
      target.sections_url = window.location.pathname;
    }

    getCartAddUrl(useJsonBundle) {
      if (!useJsonBundle || routes.cart_add_url.endsWith('.js')) return routes.cart_add_url;
      return `${routes.cart_add_url}.js`;
    }

    onSubmitHandler(form, evt) {
      evt.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification && !window.FIVEFOURFIVE_CART_DRAWER) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      const spinner = form.querySelector('.loading-overlay__spinner') || this.querySelector('.loading-overlay__spinner');
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      spinner?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = new FormData(form);
      const completeLookVariantId = Number(this.getSelectedCompleteLookVariantId(formData, form));
      const bundlePayload = this.getBundlePayload(formData, completeLookVariantId);
      formData.delete('complete_look_variant_id');

      if (bundlePayload) {
        this.appendCartNotificationSections(bundlePayload);
        config.headers.Accept = 'application/json';
        config.body = JSON.stringify(bundlePayload);
      } else {
        delete config.headers['Content-Type'];
        this.appendCartNotificationSections(formData);
        config.body = formData;
      }

      fetch(this.getCartAddUrl(!!bundlePayload), config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          let cartAddResponse = response;

          document.dispatchEvent(new CustomEvent('fivefourfive:cart-added', {
            detail: cartAddResponse
          }));

          try {
            const cartRes = await fetch('/cart.js', {
              credentials: 'same-origin',
              cache: 'no-store'
            });
            const cartData = await cartRes.json();

            if (typeof window.SLIDECART_SET_CART === 'function') {
              window.SLIDECART_SET_CART(cartData);
            } else if (typeof window.SLIDECART_UPDATE === 'function') {
              window.SLIDECART_UPDATE(cartData);
            }
          } catch (e) {
            // no-op
          }

          const cartDrawer = window.FIVEFOURFIVE_CART_DRAWER;
          if (cartDrawer && typeof cartDrawer.refresh === 'function') {
            await cartDrawer.refresh();
            cartDrawer.open?.();
            return;
          }

          if (await this.openThemeCartDrawer()) {
            return;
          }

          if (typeof window.SLIDECART_OPEN === 'function') {
            window.SLIDECART_OPEN();
            return;
          }

          if (window.SlideCart && typeof window.SlideCart.open === 'function') {
            window.SlideCart.open();
            return;
          }

          if (window.slidecart && typeof window.slidecart.open === 'function') {
            window.slidecart.open();
            return;
          }

          if (this.cartNotification) {
            this.cartNotification.renderContents(cartAddResponse);
            return;
          }

          const cartIcon = document.querySelector('a[href*="/cart"], button[aria-label*="cart" i]');
          cartIcon?.click();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
